module.exports = __webpack_public_path__ + "static/media/ColumnCellFlotation_3.eee538f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/simulator/ColumnCellFlotation_3.jpg
// module id = 423
// module chunks = 0